import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  height: 100%;

  overflow: hidden;
  background: ${({ theme }) => theme.palette.background.default};
`;

export const Content = styled.div`
  flex: 1;
  width: 100%;
  height: 100%;

  overflow: auto;
`;

export const Header = styled.div<{ $isElectronMac: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};

  height: 4.8rem;
  padding: ${({ theme }) =>
    `${theme.spacing(2)} ${theme.spacing(3)} ${theme.spacing(2)} ${theme.spacing(2)}`};

  border-bottom: ${({ theme }) => `1px solid ${theme.palette.divider}`};

  color: ${({ theme }) => theme.palette.grey[700]};

  ${({ $isElectronMac }) =>
    $isElectronMac &&
    css`
      -webkit-app-region: drag;
    `};
`;

export const SelectorWrapper = styled.div`
  flex: 1;
  min-width: 0;
`;

export const CustomSelectValue = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.h6)};
  color: ${({ theme }) => theme.palette.text.primary};

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
`;

export const HeaderInteractions = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};
  align-items: center;
  flex-shrink: 0;
`;

export const ClickableTitle = styled.button<{ $isActive?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(0.5)};
  padding: ${({ theme }) => theme.spacing(1)}
    ${({ theme }) => theme.spacing(1.5)} ${({ theme }) => theme.spacing(1)}
    ${({ theme }) => theme.spacing(2)};
  border: none;
  border-radius: ${({ theme }) => theme.spacing(2.5)};
  background: ${({ theme, $isActive }) =>
    $isActive ? theme.palette.grey[100] : 'none'};
  cursor: pointer;

  max-width: 100%;
  overflow: hidden;
  -webkit-app-region: no-drag;

  &:hover {
    background-color: ${({ theme }) => theme.palette.grey[100]};
  }
`;

export const IconContainer = styled.div<{ $color?: string | null }>`
  display: flex;
  align-items: center;
  color: ${({ theme, $color }) => $color || theme.palette.text.secondary};
  font-size: 1.6rem;
  line-height: 62.5%;
  margin-right: ${({ theme }) => theme.spacing(1)};
`;

export const NoResultsContainer = styled.div`
  padding: ${({ theme }) => theme.spacing(1.5)};
  text-align: center;
`;
